import { Component, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Panel, AutoComplete } from 'primeng/primeng';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';

import { Setting, Process } from './shared/models/setting.model';

import { HelperService } from './shared/services/helper.service';
import { SettingService } from './shared/services/setting.service';
import { DockService } from './shared/services/dock.service';
import { StoreService } from './shared/services/store.service';
import { AuthService } from './shared/services/auth.service';
import { MemberService } from './shared/services/member.service';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./home/home.component.scss']

})

export class AppComponent {

  @ViewChild('panel') panel: Panel;

  loaded: boolean = false;
  busy: Subscription;
  busyMessage: string = 'Recherche en cours';

  userId: number = null;
  userName: string;
  adminMemberUrl: string;

  constructor(
    private toastyService:ToastyService,
    private toastyConfig: ToastyConfig,
    private helperService: HelperService,
    private settingService: SettingService,
    private dockService: DockService,
    private storeService: StoreService,
    private authService: AuthService,
    private memberService: MemberService
  ) {
    // Assign the selected theme name to the `theme` property of the instance of ToastyConfig.
      this.toastyConfig.theme = 'bootstrap';
      // wait for the login emitter to test if admin -> then display hiddens menus
      authService.getLoggedInName.subscribe(role => {
        this.userId = this.authService.tokenGet(this.authService.redirectUrl).userId; // // Get current user token
          console.log(this.userId);
          if (this.userId) {
              this.memberService.getOne(this.userId).then(response => {
                  console.log(response);
                  this.userName = response.firstname + " " + response.lastname;
              });
          }

      });
  }


  ngOnInit() {

    // Flag
      this.loaded = true;

      // Get current user token
      this.userId = this.authService.tokenGet(this.authService.redirectUrl).userId;
      if (this.userId) {
          this.adminMemberUrl = environment.adminUrl + "member/" + this.userId;
          this.memberService.getOne(this.userId).then(response => {
              //console.log(response);
              this.userName = response.firstname + " " + response.lastname;
          });
      }
  }

  /**
   * Toggle function for search bar
   *
   * @param		  {Event}        event just triggered
   * @return		void
   */
  toggle(event): void {
    this.panel.toggle(event);
  }
    

  logout(key: string) {
    this.busyMessage = 'Déconnexion en cours';
    this.busy = this.authService.logout().subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts